import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";
import { AsyncSubject, forkJoin, map, Observable, of, Subject } from "rxjs";
import { DocumentModel } from "../../../models/document";
import { DocumentApiService } from 'src/app/services/domain_code/document-api.service';
import { DocumentTypeModel } from "./document_type.model";
import { FileFieldService } from "./file-field.service";
import { BackendListModel } from "../../../models/common/list.model";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImageCropperDialogComponent } from '../../dialog-box/image-cropper-dialog/image-cropper-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-file-field',
    templateUrl: './file-field.component.html',
    styleUrls: ['./file-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => FileFieldComponent),
        }
    ]
})
export class FileFieldComponent extends BaseControlValueAccessor implements OnInit {

    @Input()
    cameraIcon: boolean = false;

    @Input()
    assetSource: string = '';

    @Input()
    flatIconClass: string = 'camera';

    @Input()
    clipIcon: boolean = false;

    @Input()
    dotFloating: boolean = false;

    @Input()
    multiple: boolean = true;

    @Input()
    accept: string;

    @Input()
    files: File[] = [];

    @Output()
    filesChange = new EventEmitter<File[]>();

    @Output()
    documentUploaded = new EventEmitter<DocumentModel>();

    @Output()
    loadingFileChange = new EventEmitter<boolean>();

    @Output()
    hasUploadedFilesChange = new EventEmitter<boolean>();

    @Input()
    fileDropArea = true;

    @Input()
    lableUpload = false;

    @Input()
    showUploadedList = true;

    @Input()
    kycUpload = false;

    @Input()
    returnField = null;

    @Input()
    isSolidUploadIcon: boolean = false;
    @Input()
    Soliduploading: boolean = false;

    @Input()
    fileUploadUrl = null;

    @Input()
    bankDocList: boolean = false;

    @Input()
    cropper: boolean = false;

    // fileUpdated: boolean = false;

    _documentTypeGroup: string = null;
    @Input()
    get documentTypeGroup() {
        return this._documentTypeGroup;
    }

    set documentTypeGroup(value) {
        this._documentTypeGroup = value;
        if (value != null) {
            this.getDocumentTypesByGroup();
        } else {
            if (this.documentTypeDevName == null) {
                console.error('You must provide a documentTypeDevName or documentTypeGroup');
            }
        }
    }

    _documentTypeDevName: string = null;
    @Input()
    get documentTypeDevName() {
        return this._documentTypeDevName;
    }

    set documentTypeDevName(value) {
        this._documentTypeDevName = value;
        if (value != null) {
            this.getDocumentTypeByDevName();
        } else {
            if (this.documentTypeGroup == null) {
                console.error('You must provide a documentTypeDevName or documentTypeGroup');
            }
        }
    }

    current_user;
    document_type;
    documentTypes: DocumentTypeModel[] = [];
    selectedDocumentType: DocumentTypeModel = null;
    override _data: DocumentModel[] = [];
    displayedColumns: string[] = ['original_filename', 'document_size', 'document_type', 'created_by', 'action'];
    displayedColumns1: string[] = ['original_filename', 'action'];

    constructor(private docService: DocumentApiService, private fileFieldService: FileFieldService, private snackBar: MatSnackBar, private dialog: MatDialog,) {
        super();
    }

    ngOnInit(): void {
        this.current_user = JSON.parse(localStorage.getItem('current_user'));
        setTimeout(() => {
            if (this.documentTypeDevName == null && this.documentTypeGroup == null) {
                console.error('You must provide a documentTypeDevName or documentTypeGroup');
            }
        },
            1000);
    }

    removeFile(doc, index) {
        if (doc.created_by.email === this.current_user.email) {
            if (this.data[index].id != null) {
                //inside subscribe for document/:id/ DELETE
                this.docService.deleteDocument(this.data[index].id).subscribe(() => {
                    this.removeFileEntryForIndex(index);
                    this.snackBar.open(`${doc.original_filename} deleted.`, 'Close', {
                        duration: 3000,
                    });
                });
            } else {
                this.removeFileEntryForIndex(index);
                this.snackBar.open(`${doc.original_filename} deleted.`, 'Close', {
                    duration: 3000,
                });
            }
        } else {
            this.snackBar.open("Only the user who uploaded the document has the permission to delete it!!", 'Close', {
                duration: 3000,
            });
        }
    }

    removeFileEntryForIndex(index) {
        this.files.splice(index, 1);
        this.filesChange.emit(this.files);
        let old_data = [...this.data];
        old_data.splice(index, 1);
        this.data = old_data;

        this.onChange(this.data);
    }

    addFiles(files) {
        if (this.cameraIcon) {
            console.log("started")

        }

        if (files && files.length > 0) {
            this.Soliduploading = true;
            this.hasUploadedFilesChange.emit(this.Soliduploading);
            if (this.selectedDocumentType == null) {
                this.Soliduploading = false;
            this.hasUploadedFilesChange.emit(this.Soliduploading);

                this.errors = ['Please select a document type'];
            } else {
                this.errors = [];

                if (this.multiple) {
                    let sameFileError = false;
                    for (let file of files) {
                        for (let item of this.data) {
                            if (file.name === item.original_filename + '.' + item.extension) {
                                this.snackBar.open('File(s) uploading failed!!', 'Close', {
                                    verticalPosition: 'top',
                                    duration: 3000,
                                });
                                if (this.errors.length == 0) {
                                    this.errors = [`File(s) that already exists: `];
                                }
                                this.errors.push(`${file.name}`);
                                sameFileError = true;
                            }
                        }
                    }
                    if (sameFileError) {
                        this.Soliduploading = false;
                        this.hasUploadedFilesChange.emit(this.Soliduploading);
                        return;
                    }
                    if (this.files.length + files.length < this.selectedDocumentType.min_files) {
                        this.errors = [`You should upload at least ${this.selectedDocumentType.min_files} files`];
                        this.Soliduploading = false;
                        this.hasUploadedFilesChange.emit(this.Soliduploading);
                    }
                    if (this.files.length + files.length > this.selectedDocumentType.max_files) {
                        this.errors = [`You can upload only ${this.selectedDocumentType.max_files} files`];
                        this.Soliduploading = false;
                        this.hasUploadedFilesChange.emit(this.Soliduploading);
                        return;  // stop execution if max files exceeded
                    }
                } else {
                    if (this.files.length + files.length < this.selectedDocumentType.min_files) {
                        this.Soliduploading = false;
                        this.hasUploadedFilesChange.emit(this.Soliduploading);
                        this.errors = ['This field is required'];
                    }
                }

            }

            // this.Soliduploading = true;
            console.debug('Uploading files...', files)


            let synchronizer: Observable<any>[] = [];

            for (let file of files) {
                try {
                    // synchronizer.push();
                    this.addFile(file);
                } catch (exc: any) {
                    this.snackBar.open(exc.message, 'Close', {
                        duration: 2000,
                    });
                }
            }
        }
    }


    addFile(file) {
        if (this.errors.length > 0) {
            return of(null);
        }

        if (this.files == null || this.files == undefined) {
            this.files = [];
        }
        if (this.multiple == false && this.selectedDocumentType.max_files == 1) {
            this.files = [];
        }

        if (this.selectedDocumentType.mime_accept_string.indexOf(file.type) < 0) {
            this.files = [];
            this.Soliduploading = false;
            this.hasUploadedFilesChange.emit(this.Soliduploading);
            this.errors = ["Invalid document type!!"];
            return of(null);
        }

        if (this.selectedDocumentType.max_size < file.size) {
            this.files = [];
            this.Soliduploading = false;
            this.hasUploadedFilesChange.emit(this.Soliduploading);
            this.errors = ["File size limit exceeded!!"];
            return of(null);
        }

        if (this.files.length < this.selectedDocumentType.max_files) {
            this.loadingFileChange.emit(true);
            let fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
            let fileExtension = file.name.split('.').pop();

            const document_obj = new FormData();
            document_obj.append('original_filename', fileNameWithoutExtension)
            document_obj.append('document_file', file)
            document_obj.append('extension', fileExtension.toLowerCase())
            document_obj.append('document_type', this.selectedDocumentType.id.toString())
            return this.postDocData(document_obj, file); // Post Documents
        } else {
            this.errors.push('You can only upload ' + this.selectedDocumentType.max_files + ' files');
            return of(null);
        }
    }

    readableFileSize(size) {
        var units = ['B', 'KB', 'MB'];
        var i = 0;
        while (size >= 1024) {
            size /= 1024;
            ++i;
        }
        return size?.toFixed(2) + ' ' + units[i];
    }

    postDocData(document, file) {
        let obs = null;

        if (this.fileUploadUrl == null)
            obs = this.docService.postDocument(document)
        else
            obs = this.docService.postDocument(document, this.fileUploadUrl)

        obs.subscribe(response => {
            if (this.returnField == null) {
                if (!this.multiple) {
                    this.data = response
                    console.log('this.data', this.data)
                    console.log("completed");
                    this.loadingFileChange.emit(false);
                } else {
                    //okay
                    this.pushIntoData(response);
                }
                this.documentUploaded.emit(response);
            } else {
                if (this.selectedDocumentType.max_files == 1) {
                    this.data = response[this.returnField]
                } else {
                    this.pushIntoData(response[this.returnField]);
                }
                this.documentUploaded.emit(response[this.returnField]);
            }
            this.files.push(file);
            this.Soliduploading = false;
            this.hasUploadedFilesChange.emit(this.Soliduploading);
            this.filesChange.emit(this.files);
            // this.fileUpdated = true;

        },
            error => {
                if (error.status === 400) {
                    this.errors = error.error.document_file;
                    this.Soliduploading = false;
                    this.hasUploadedFilesChange.emit(this.Soliduploading);
                }
            },
            () => {
                this.Soliduploading = false;
                this.hasUploadedFilesChange.emit(this.Soliduploading);
            });
        return obs;
    }

    pushIntoData(apiData) {
        let old_data = [...this.data]
        old_data.push(apiData)
        this.data = old_data;

    }
    mime_accept_string_pdf;
    mime_accept_string_image;
    mime_accept_string_tms;
    getDocumentTypeByDevName() {
        this.fileFieldService.getDocumentTypeByDevName(this.documentTypeDevName).subscribe((data: DocumentTypeModel) => {
            this.selectedDocumentType = data;
            this.mime_accept_string_pdf = this.selectedDocumentType.mime_accept_string.substring("application/".length);
            const fileTypesArray = this.selectedDocumentType.mime_accept_string.split(',');
            const modifiedFileTypesArray = fileTypesArray.map(type => type.replace("image/", ""));
            this.mime_accept_string_image = modifiedFileTypesArray.join(',');
            // const filteredFileTypes = fileTypesArray.map(type => type.replace("application/", ""));
            // this.mime_accept_string_tms = filteredFileTypes.map(type => type.replace("image/", ""));
        });
    }

    getDocumentTypesByGroup() {
        this.fileFieldService.getDocumentTypes(this.documentTypeGroup).subscribe((data: BackendListModel<DocumentTypeModel>) => {
            this.documentTypes = data.results;
            if (data.results?.length == 1) {
                this.selectedDocumentType = data.results[0];
            }
        });
    }

    onDocumentTypeChange(selected) {
        this.selectedDocumentType = selected;
    }

    override validate(val) {
        this.errors = [];

        if (this.selectedDocumentType == null) {
            this.errors.push('Document type is required for file field');
        } else {
            if (this.multiple) {
                if (val.length < this.selectedDocumentType.min_files) {
                    this.errors.push('You need to upload at least ' + this.selectedDocumentType.min_files + ' file(s)');
                }
                if (val.length > this.selectedDocumentType.max_files) {
                    this.errors.push('You can only upload ' + this.selectedDocumentType.max_files + ' file(s)');
                }
            } else {
                if (this.selectedDocumentType.min_files > 0) {
                    this.errors.push('This field is required.');
                }
            }
        }
    }


    imageChangedEvent: any = '';

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.openCropperDialog(event)
    }

    openCropperDialog(image) {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { imageChanged: image }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                this.addFiles([item]);
            } else {
                this.imageChangedEvent = ''
                return;
            }
        })
    }
}
